import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export abstract class PreloaderServiceBase {
    abstract preload(): Observable<boolean>;
}
